<template>
    <div class="color-picker" :class="activeClass">
        <div class="dropdown" :class="selectedClass">
            <button class="btn form-control dropdown-toggle" type="button" :id="id" data-bs-toggle="dropdown" aria-expanded="false">
                {{ selected?.name ?? label }}
            </button>
            <span v-if="selected.name" class="vehica-form-button__clear vehica-form-button__clear--list" @click="clear"><i class="fas fa-times"></i></span>
            <ul class="dropdown-menu" :aria-labelledby="id">
                <li v-for="option in list" :key="option.id">
                    <a :class="'dropdown-item' + isActive(option, selected?.name)" href="" @click.prevent="selected = option">
                        <div class="color-swatch" :style="{'background-color': option.value}"></div>
                        {{ option.name }}
                    </a>
                </li>
            </ul>
        </div>
        <label class="vehica-results__field__label">
            {{ label }}
        </label>
    </div>
</template>
<script>
    //TODO: Should we get this from the backend?
    export const ColorList = [
        { name: 'Beige', value: '#f5f5dc' },
        { name: 'Black', value: '#000000' },
        { name: 'Blue', value: '#2222ff' },
        { name: 'Brown', value: '#a52a2a' },
        { name: 'Gold', value: '#ffd700' },
        { name: 'Gray', value: '#8c8c8c' },
        { name: 'Green', value: '#006a4e' },
        { name: 'Orange', value: '#ffa500' },
        { name: 'Purple', value: '#7d0552' },
        { name: 'Red', value: '#ff0000' },
        { name: 'Silver', value: '#bcc6cc' },
        { name: 'White', value: '#ffffff' },
        { name: 'Yellow', value: '#fef250' }
    ];

    let idCounter = 1;

    export default {
        props: ['color', 'label'],
        emits: ['input'],
        data: function () {
            return {
                id: '',
                list: ColorList,
                selected: {}
            }
        },
        computed: {
            activeClass() {
                return this.selected?.name ? 'vehica-active' : '';
            },
            selectedClass() {
                return this.selected?.name ? 'selected' : '';
            }
        },
        methods: {
            clear() {
                this.selected = {};
            },
            isActive(option, value) {
                return option.name === value ? ' active' : '';
            },
            updated() {
                const color = this.color;
                this.selected = this.list.find(i => i.name === color) ?? {};
            }
        },
        watch: {
            color() {
                this.updated();
            },
            selected() {
                this.$emit('input', this.selected?.name ?? null);
            }
        },
        created() {
            this.id = 'cp' + (idCounter++);
            this.updated();
        }
    }
</script>